import { Capacitor } from "@capacitor/core";
import {
  AppUpdate,
  AppUpdateAvailability,
} from "@capawesome/capacitor-app-update";

const useAppUpdate = () => {
  const getUpdateAvailable = async () => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    const result = await AppUpdate.getAppUpdateInfo();
    return result.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE;
  };

  const getCurrentAppVersion = async () => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    const result = await AppUpdate.getAppUpdateInfo();
    if (Capacitor.getPlatform() === "android") {
      return result.currentVersionCode;
    } else {
      return result.currentVersionName;
    }
  };

  const getAvailableAppVersion = async () => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    const result = await AppUpdate.getAppUpdateInfo();
    if (Capacitor.getPlatform() === "android") {
      return result.availableVersionCode;
    } else {
      return result.availableVersionName;
    }
  };

  const openAppStore = async () => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    await AppUpdate.openAppStore({
      appId: "6758756198",
    });
  };

  const performImmediateUpdate = async () => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    const result = await AppUpdate.getAppUpdateInfo();
    if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
      return;
    }
    if (result.immediateUpdateAllowed) {
      await AppUpdate.performImmediateUpdate();
    }
  };

  const startFlexibleUpdate = async () => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    const result = await AppUpdate.getAppUpdateInfo();
    if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
      return;
    }
    if (result.flexibleUpdateAllowed) {
      await AppUpdate.startFlexibleUpdate();
    }
  };

  const completeFlexibleUpdate = async () => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    await AppUpdate.completeFlexibleUpdate();
  };

  const updateChangeListener = (callback: any) => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    AppUpdate.addListener("onFlexibleUpdateStateChange", callback).then();
  };

  return {
    getCurrentAppVersion,
    getAvailableAppVersion,
    openAppStore,
    performImmediateUpdate,
    startFlexibleUpdate,
    completeFlexibleUpdate,
    updateChangeListener,
    getUpdateAvailable,
  };
};

export default useAppUpdate;
